<template>
  <section v-if="page" class="calc-seo-intro" :aria-labelledby="headingId">
    <h1 :id="headingId">{{ page.h1 }}</h1>
    <p class="lede">{{ page.lede }}</p>
    <p v-for="(p, i) in page.paragraphs" :key="'p-' + i">{{ p }}</p>

    <div v-if="page.exampleScenario" class="example-scenario">
      <h2>{{ page.exampleScenario.title }}</h2>
      <p>{{ page.exampleScenario.intro }}</p>
      <ul>
        <li v-for="(b, i) in page.exampleScenario.bullets" :key="'b-' + i">{{ b }}</li>
      </ul>
      <p class="citable"><strong>Citable summary:</strong> {{ page.exampleScenario.citable }}</p>
    </div>

    <div v-for="section in visibleSections" :key="section.id || section.h2" class="intro-section">
      <h2 v-if="section.h2">{{ section.h2 }}</h2>
      <ul v-if="section.bullets">
        <li v-for="(b, i) in section.bullets" :key="i">{{ b }}</li>
      </ul>
    </div>
  </section>
</template>

<script>
import crawlContent from '@/seo/crawl-content.json';

export default {
  name: 'CalcSeoIntro',
  props: {
    path: { type: String, required: true },
  },
  computed: {
    page() {
      return (crawlContent.pages || []).find((p) => p.path === this.path) || null;
    },
    headingId() {
      return `calc-seo-h1-${(this.path || '').replace(/\//g, '-') || 'root'}`;
    },
    visibleSections() {
      if (!this.page || !this.page.sections) return [];
      return this.page.sections.filter((s) => s.id === 'what-it-computes' || s.id === 'inputs');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/app.scss';

.calc-seo-intro {
  max-width: 960px;
  margin: 0 auto 1.5rem auto;
  padding: 1.5rem 1.25rem 0.5rem;
  color: rgba($body-color, 0.95);
  line-height: 1.6;
}

h1 {
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 0.75rem;
  color: $body-color;
}

.lede {
  font-size: 1.15rem;
  color: $secondary;
  margin-bottom: 1rem;
}

.example-scenario,
.intro-section {
  margin-top: 1.25rem;
  padding: 1rem 1.1rem;
  background: lighten($body-bg, 4%);
  border: 1px solid rgba($body-color, 0.15);
  border-radius: 0.5rem;
}

h2 {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.65rem;
  color: $primary;
}

ul {
  margin: 0.5rem 0 0.75rem 1.2rem;
  padding: 0;

  li {
    margin-bottom: 0.4rem;
  }
}

.citable {
  margin-bottom: 0;
  font-size: 0.98rem;
}

@media (max-width: 768px) {
  h1 {
    font-size: 1.65rem;
  }

  .lede {
    font-size: 1.05rem;
  }
}
</style>
